import styled from 'styled-components';

export const FullScreenModal = styled.div``;

export const TermsContainer = styled.div`
  max-width: 800px;
  width: 100%;

  margin: 0 auto;

  padding: 16px;

  h2 {
    font-weight: ${({ theme }) => theme.core.fontWeight.medium};
  }
`;
